import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import PeopleIcon from '@mui/icons-material/People';
import ScienceIcon from '@mui/icons-material/Science';
import { Box, CardContent, Grid } from '@mui/material';
import React from 'react';
import { Heading, Text } from '../atomic';
import GreenCornerCard from '../ui/GreenCornerCard';

/**
 * Collaboration types section showing different ways to collaborate
 *
 * @returns {JSX.Element} Collaboration types section component
 */
function CollaborationTypesSection() {
  const collaborationTypes = [
    {
      icon: <HealthAndSafetyIcon />,
      title: 'Enterprise Organizations',
      description:
        'Transform your business operations with AI-powered solutions',
      link: '/lets-collaborate',
    },
    {
      icon: <PeopleIcon />,
      title: 'Technology Consultants',
      description:
        'Join our elite network of healthcare transformation experts',
      link: '/join-consultant',
    },
    {
      icon: <AutoAwesomeIcon />,
      title: 'Systems Integrators',
      description: 'Partner to deliver comprehensive healthcare solutions',
      link: '/join-integrator',
    },
    {
      icon: <ScienceIcon />,
      title: 'Innovation Partners',
      description: 'Co-create the future of healthcare technology',
      link: '/lets-collaborate',
    },
  ];

  return (
    <Box sx={{ mb: 8 }}>
      <Heading
        variant="h2"
        sx={{ mb: 4, fontSize: '1.75rem', fontWeight: 600 }}
      >
        How We Collaborate
      </Heading>
      <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
        {collaborationTypes.map((type, index) => (
          <Grid item xs={12} md={6} lg={3} key={index}>
            <GreenCornerCard
              index={index}
              onClick={() => window.location.assign(type.link)}
            >
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ color: 'primary.main', mb: 2 }}>
                  {React.cloneElement(type.icon, { sx: { fontSize: 48 } })}
                </Box>
                <Heading
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontSize: '1.1rem',
                    color: 'var(--color-heading)',
                  }}
                >
                  {type.title}
                </Heading>
                <Text
                  sx={{ fontSize: '0.9rem', color: 'var(--color-text-muted)' }}
                >
                  {type.description}
                </Text>
              </CardContent>
            </GreenCornerCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default CollaborationTypesSection;
